import { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/common/Loader";
import { Field, TextInput, SpecialistsEditor, PasswordChangeCard } from "@/components/common/Forms";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const Info = ({ label, value }) => (
  <div>
    <p className="field-label mb-1">{label}</p>
    <p className="text-sm">{value || "—"}</p>
  </div>
);

export default function Account() {
  const { user, setUser, logout } = useAuth();
  const c = user.center;
  const [form, setForm] = useState({ phone: c.phone || "", instagram: c.instagram || "", website: c.website || "", specialists: c.specialists || [] });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (form.specialists.some((s) => !s.first_name.trim() || !s.last_name.trim())) return toast.error("Completa nome e cognome di ogni specialist");
    setBusy(true);
    try {
      const r = await api.patch("/me/center", form);
      setUser({ ...user, center: r.data });
      toast.success("Modifiche salvate");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Il mio account" title={c.center_name} subtitle={c.client_type_name ? `Tipologia: ${c.client_type_name}` : undefined} />
      <section className="lux-card p-6 sm:p-8" data-testid="account-company-info">
        <h2 className="text-2xl font-normal mb-6">Dati del centro</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          <Info label="Ragione sociale" value={c.company_name} />
          <Info label="Titolare" value={`${c.owner_first_name} ${c.owner_last_name}`} />
          <Info label="Partita IVA" value={c.vat_number} />
          <Info label="Codice fiscale" value={c.tax_code} />
          <Info label="Codice SDI / PEC" value={[c.sdi_code, c.pec].filter(Boolean).join(" · ")} />
          <Info label="Email di accesso" value={c.email} />
          <Info label="Indirizzo" value={`${c.address}, ${c.zip_code} ${c.city} (${c.province})`} />
          <Info label="Protocolli abilitati" value={c.enabled_protocols.map((p) => p.name).join(", ")} />
        </div>
        <p className="mt-6 text-xs text-warm-text">Per modificare questi dati scrivici dalla sezione Assistenza: ci pensiamo noi.</p>
      </section>

      <form onSubmit={save} className="lux-card p-6 sm:p-8 space-y-6" data-testid="account-edit-form">
        <h2 className="text-2xl font-normal">Contatti e team</h2>
        <div className="grid sm:grid-cols-3 gap-5">
          <Field label="Telefono"><TextInput data-testid="account-phone-input" value={form.phone} onChange={set("phone")} required /></Field>
          <Field label="Instagram"><TextInput data-testid="account-instagram-input" value={form.instagram} onChange={set("instagram")} /></Field>
          <Field label="Sito web"><TextInput data-testid="account-website-input" value={form.website} onChange={set("website")} /></Field>
        </div>
        <div>
          <p className="field-label">Le tue specialist</p>
          <SpecialistsEditor value={form.specialists} onChange={(v) => setForm({ ...form, specialists: v })} testid="account-specialists" />
        </div>
        <button data-testid="account-save-btn" disabled={busy} className="btn-gold">{busy ? "Salvataggio…" : "Salva le modifiche"}</button>
      </form>

      <PasswordChangeCard />
      <button data-testid="center-logout-btn" onClick={logout} className="btn-link">Esci dall'account</button>
    </div>
  );
}
